import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { IConversationsUserPersona } from '@newo/api/gateway';
import type {
    TUserPersonaFilters,
    TActsFilters
} from '@/pages/Conversations/Conversations.types';
import { APP_VERSION } from '@/const';

type IConversationsState = {
    actsFilters: TActsFilters;
    setActsFilters: (filters: TActsFilters) => void;
    userPersonaFilters: TUserPersonaFilters;
    setUserPersonaFilters: (filters: TUserPersonaFilters) => void;
    clearFilters: () => void;
    selectedUserPersona?: IConversationsUserPersona;
    selectUserPersona: (persona?: IConversationsUserPersona) => void;
    personaDetails?: IConversationsUserPersona;
    togglePersonaDetails: (persona?: IConversationsUserPersona) => void;
    flush: () => void;
};

const initialState = {
    actsFilters: {},
    userPersonaFilters: {},
    selectedUserPersona: undefined,
    personaDetails: undefined
};

const useConversationStore = create<IConversationsState>()(
    persist(
        (set) => ({
            ...initialState,
            setActsFilters: (filters) => {
                set((state) => ({
                    actsFilters: { ...state.actsFilters, ...filters }
                }));
            },
            setUserPersonaFilters: (filters) => {
                set((state) => ({
                    userPersonaFilters: {
                        ...state.userPersonaFilters,
                        ...filters
                    }
                }));
            },
            clearFilters: () => {
                set(() => ({ actsFilters: {}, userPersonaFilters: {} }));
            },
            selectUserPersona: (persona) => {
                set(() => ({
                    selectedUserPersona: persona
                }));
            },
            togglePersonaDetails: (persona) => {
                set(() => ({ personaDetails: persona }));
            },
            flush: () => {
                set(initialState);
            }
        }),
        {
            name: 'conversations-store',
            storage: createJSONStorage(() => globalThis.localStorage),
            partialize: (state) => ({
                userPersonaFilters: {
                    skip_without_user_messages:
                        state.userPersonaFilters.skip_without_user_messages,
                    hide_not_found: state.userPersonaFilters.hide_not_found
                }
            }),
            version: APP_VERSION
        }
    )
);

export default useConversationStore;
